@if (loading) {
  <div>
    <lib-frontend-spinner text="Daten werden geladen" />
  </div>
}
@else {
  <div>
    @switch(state) 
    {
      @case (CouponViewStateEnum.ShowCodeEntry)
      {
        <p>{{parameterService.channel?.coupontext_input ?? 'Gutschein / Rabatt einlösen mit:'}}</p>
        <div class="form-group mb-3">
          <input type="text" class="form-control text-center" [(ngModel)]="coupon_code" aria-label="Gutscheincode"/>
        </div>
        <button class="btn btn-primary" (click)="einloesen()">Einlösen</button>
        <button class="btn btn-default" (click)="cancel()">Abbrechen</button>  
      }
      @case (CouponViewStateEnum.ShowValue)
      {
        <p>Der Gutschein hat einen aktuell Wert von {{ resp.amount | currency : 'EUR' : 'symbol' }}</p>
        <button class="btn btn-primary mt-3" *ngIf="(parameterService.payment?.amount ?? 0) * 1 >= resp.amount * 1" (click)="add_to_paymentlist()">
          Jetzt {{(parameterService.payment?.amount ?? 0) * 1 >= resp.amount * 1 ? 'vollständig' : 'teilweise'}} einlösen
        </button>
        <button class="btn btn-default mt-3" (click)="cancel()">Abbrechen</button>  
      }
      @case(CouponViewStateEnum.Invalid)
      {
        <p [innerHtml]="parameterService.channel?.coupontext_error ?? 'Der Gutscheincode ist nicht gültig oder wurde bereits eingelößt!'"></p>
        <button class="btn btn-default mt-3" (click)="cancel()">>></button>  
      }
      @case(CouponViewStateEnum.CashingError)
      {
        <p>Die Gutscheineinlösung hat nicht geklappt. Versuchen Sie eine andere Möglichkeit.</p>
      }
    }
  </div>
}